export const Y_AXIS_TICK_SIZE = 20;
export const Y_AXIS_TICK_PADDING = 10;
export const Y_AXIS_TITLE_PADDING = 13;
export const Y_AXIS_TITLE = 10 + Y_AXIS_TITLE_PADDING;

export const X_AXIS_TICK_PADDING = 20;
export const X_AXIS_TITLE_PADDING = 15;
export const X_AXIS_TITLE = 10 + X_AXIS_TITLE_PADDING;
